import HeaderFilterSearchPage from "components/HeaderFilterSearchPage";
import ProductCard from "components/ProductCard";
import { CollegeProduct } from "data/data";
import { FC } from "react";
import ButtonCircle from "shared/Button/ButtonCircle";
import Input from "shared/Input/Input";
import { useProductsWithQuery } from "store/utils/hooks";

import { _renderLoading } from "components/SectionSliderProductCard";
import { useSearchParams } from "react-router-dom";

export interface PageSearchProps {
  className?: string;
}

const PageSearch: FC<PageSearchProps> = ({ className = "" }) => {
  const [query, setQuery] = useSearchParams();
  const searchQuery = query.get("search") || "";
  const categoryQuery = query.get("category") || "";
  const orderBy = query.get("order_by") || "";

  const queryParams: any = {};
  if (searchQuery) queryParams.search = searchQuery;
  if (categoryQuery) queryParams.category = categoryQuery;
  if (orderBy) {
    // Map order_by to backend orders param
    if (orderBy === 'price') {
      queryParams.orders = 'price';
    } else if (orderBy === 'total_sales') {
      queryParams.orders = 'most_relevant';
    } else if (orderBy === 'created_at') {
      queryParams.orders = 'most_recently';
    } else {
      queryParams.orders = orderBy; // for name, etc.
    }
  }

  const [products, isLoading] = useProductsWithQuery(queryParams, true);

  const onChange = (event: any) => {
    const { name, value } = event?.target;
    setQuery({ ...Object.fromEntries(query), [name]: value });
  };
  return (
    <div className={`nc-PageSearch  ${className}`} data-nc-id="PageSearch">
      <div
        className={`nc-HeadBackgroundCommon h-24 2xl:h-28 top-0 left-0 right-0 w-full bg-primary-50 dark:bg-neutral-800/20 `}
        data-nc-id="HeadBackgroundCommon"
      />
      <div className="container">
        <header className="max-w-2xl mx-auto -mt-10 flex flex-col lg:-mt-7">
          <form
            className="relative w-full"
            onSubmit={(e) => {
              e.preventDefault();
            }}
          >
            <label
              htmlFor="search-input"
              className="text-neutral-500 dark:text-neutral-300"
            >
              <span className="sr-only">Search all icons</span>
              <Input
                className="shadow-lg border-0 dark:border"
                id="search-input"
                type="search"
                placeholder="Escriba la palabra clave"
                sizeClass="pl-14 py-5 pr-5 md:pl-16"
                rounded="rounded-full"
                name="search"
                value={query.get("search") || ""}
                onChange={onChange}
              />
              <ButtonCircle
                className="absolute right-2.5 top-1/2 transform -translate-y-1/2"
                size=" w-11 h-11"
                type="submit"
              >
                <i className="las la-arrow-right text-xl"></i>
              </ButtonCircle>
              <span className="absolute left-5 top-1/2 transform -translate-y-1/2 text-2xl md:left-6">
                <svg
                  className="h-5 w-5"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.5 21C16.7467 21 21 16.7467 21 11.5C21 6.25329 16.7467 2 11.5 2C6.25329 2 2 6.25329 2 11.5C2 16.7467 6.25329 21 11.5 21Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M22 22L20 20"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            </label>
          </form>
        </header>
      </div>

      <div className="container py-16 lg:pb-28 lg:pt-20 space-y-16 lg:space-y-28">
        <main>
          {/* FILTER */}
          <HeaderFilterSearchPage />
          <div className="w-full">
            {isLoading && <div className="w-full flex justify-center"> {_renderLoading()}</div>}
            {/* LOOP ITEMS */}
            <div className="w-full grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-8 gap-y-10 mt-8 lg:mt-0">
              {(products as CollegeProduct[])?.map((item, index) => (
                <ProductCard data={item} key={index} />
              ))}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default PageSearch;
